function MobileTrackingSkeleton() {
    return (
        <div className="flex flex-col gap-4">
            {[...Array(5)].map((_, index) => (
                <div key={index} className="bg-white shadow-lg flex flex-col rounded-3xl py-4 p-2 gap-4">
                    <div className="flex gap-2 px-2 p-1">
                        <div className="bg-elitLightBackground h-4 w-4 rounded" />
                        <div className="bg-elitLightBackground h-4 w-56 rounded" />
                    </div>
                    <div className="bg-elitLightBackground rounded w-full h-14" />
                    <div className="flex gap-2 px-2 p-1">
                        <div className="flex gap-2">
                            <div className="bg-elitLightBackground h-4 w-4 rounded" />
                            <div className="bg-elitLightBackground h-4 w-44 rounded" />
                        </div>
                        <div className="bg-elitLightBackground"></div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default MobileTrackingSkeleton;
